import io from 'socket.io-client'
import { SOCKET_URL } from '@/config'
import userStore from './user'

const state = {
  socket: io(SOCKET_URL, { query: { token: userStore.getters.user()['access_token'] } })
}

const getters = {
  socket () {
    return state.socket
  }
}

const mutations = {
  refreshSocket (state) {
    state.socket = io(SOCKET_URL, { query: { token: userStore.getters.user()['access_token'] } })
  }
}

export default {
  state,
  getters,
  mutations
}
